<template>
  <div id="formGeral">
    <div class="container">
      <!-- <div class="row">
        <v-col cols="12" class="">
          <h3 class="text-center allcaps ml-2 mt-0 mb-3"><span class="white green--text px-1">Pré-inscrição</span></h3>
          <p class="white--text mb-0 text-center">Assine nossa newsletter e receba as novidades em primeira mão:</p>
        </v-col>
      </div> -->
      <div class="row hb-row">
        <v-col cols="12">
          <div id="hubspotForm" v-once></div>
        </v-col>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FormNews',
  data() {
    return {
      title: 'oi',
    }
  },
  mounted() {
    const script = document.createElement("script");
    script.src="https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);
    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "7879926",
          formId: "d115da7d-87a9-446c-9896-cf5f5f85302a",
          target: "#hubspotForm"
        })
      }
    })
  }
}
</script>

<style lang="scss">
@import '@/variables/style.scss';

#formGeral {
  padding: 0px 0px;
  @include xs {
    padding: 0px;
  }

  .hb-row {
    padding: 0px 0px;
  }
  #hubspotForm{
    width: 100%;
    @include xs {
      // width: 90%;
    }
  }
}
</style>